// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import '@/assets/font/font.css'
import ElementUI from 'element-ui'
import components from './components'
import { formatUrl,formatUrlList,lineBreak } from './util'
import {  } from './util'

Vue.use(components)
Vue.config.productionTip = false
Vue.prototype.formatUrl = formatUrl
Vue.prototype.formatUrlList = formatUrlList
Vue.prototype.lineBreak = lineBreak
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js